import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { Section, ContentContainer, ChecklistItem } from '../../styles';
import {
  ExpectationsHeading,
  ExpectationsSubtext,
  StepsContainer,
  ExpectationsStepCard,
  StepContentBox,
  StepContentWrapper,
  ExpectationsStepNumber,
  ExpectationsStepTitle,
  ExpectationsDescriptionText,
  ExpectationsCardTitle,
  ChecklistContainer,
  ExpectationsChecklistText,
  ImageGridItem,
  ImageWrapper,
  StepImage,
  ClosingSection,
  CollaborativeTextPrimary,
  ButtonsGrid,
  ExpectationsButton,
  ExpectationsDisclaimerText,
} from './styles';
import { expectsteps } from '../../constants';
import {
  openSimplePracticeConsultation,
  openSimplePracticeClientPortal,
} from '../../../../../utils/simplePractice';

const ExpectationsSection = () => {
  const navigate = useNavigate();

  const handleMeetPractitioners = () => {
    navigate('/practitioners');
  };

  return (
    <Section>
      <ContentContainer>
        <ExpectationsHeading>What You Can Expect in a Session?</ExpectationsHeading>

        <ExpectationsSubtext>
          At Nirva, every session is designed to feel safe, comfortable, and supportive, whether
          it's your very first experience with hypnosis or you've explored it before.
        </ExpectationsSubtext>

        <StepsContainer>
          {expectsteps.map((step, index) => {
            const isEvenStep = step.number % 2 === 0;
            return (
              <ExpectationsStepCard key={index}>
                <Grid
                  container
                  spacing={{ xs: 2, md: 4 }}
                  alignItems="center"
                  sx={{
                    flexWrap: { xs: 'wrap', lg: 'nowrap' },
                    flexDirection: { xs: 'column', lg: isEvenStep ? 'row-reverse' : 'row' },
                  }}
                >
                  <StepContentBox>
                    <StepContentWrapper>
                      <ExpectationsStepNumber>STEP #{step.number}.</ExpectationsStepNumber>
                      <ExpectationsStepTitle>{step.title}</ExpectationsStepTitle>

                      <ExpectationsDescriptionText $hasSubtitle={!!step.subtitle}>
                        {step.description}
                      </ExpectationsDescriptionText>

                      {step.subtitle && (
                        <ExpectationsCardTitle>{step.subtitle}</ExpectationsCardTitle>
                      )}

                      {step.checklist && step.checklist.length > 0 && (
                        <ChecklistContainer>
                          {step.checklist.map((item, idx) => (
                            <ChecklistItem key={idx}>
                              <CheckIcon />
                              <ExpectationsChecklistText>{item}</ExpectationsChecklistText>
                            </ChecklistItem>
                          ))}
                        </ChecklistContainer>
                      )}
                    </StepContentWrapper>
                  </StepContentBox>

                  <ImageGridItem item xs={12} md={12} lg={5}>
                    <ImageWrapper>
                      <StepImage src={step.image} alt={step.title} />
                    </ImageWrapper>
                  </ImageGridItem>
                </Grid>
              </ExpectationsStepCard>
            );
          })}
        </StepsContainer>

        <ClosingSection>
          <CollaborativeTextPrimary>
            Every Session Is A Collaborative Process—You Are Never "Under" Or Out Of Control. You
            Are Always The Guide Of Your Own Journey; Your Practitioner Simply Walks Beside You.
          </CollaborativeTextPrimary>
          {/* <CollaborativeTextSecondary>Ready To Begin?</CollaborativeTextSecondary> */}

          <ButtonsGrid container justifyContent="center">
            <Grid item xs={12} sm={6}>
              <ExpectationsButton fullWidth onClick={openSimplePracticeConsultation}>
                Request a Free 30-Minute Consultation
              </ExpectationsButton>
            </Grid>
            <Grid item xs={12} sm={6}>
              <ExpectationsButton fullWidth onClick={handleMeetPractitioners}>
                Meet Our Practitioners
              </ExpectationsButton>
            </Grid>
            <Grid item xs={12} sm={6}>
              <ExpectationsButton fullWidth onClick={openSimplePracticeClientPortal}>
                Client Portal
              </ExpectationsButton>
            </Grid>
          </ButtonsGrid>

          <ExpectationsDisclaimerText>
            Note: Hypnotherapy is a supportive wellness service and is not a substitute for medical,
            mental health, psychiatric, or crisis care. If you are in crisis or immediate danger,
            please contact 911, 988, or your local emergency service.
          </ExpectationsDisclaimerText>
        </ClosingSection>
      </ContentContainer>
    </Section>
  );
};

export default ExpectationsSection;
